<label class="textColour">{{title}}</label>

<form [formGroup]="meetingForm" mat-dialog-content>

  <!-- SUBJECT -->
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Subject</mat-label>
    <input matInput formControlName="meetingSubject" />
    <mat-error
      *ngIf="
        meetingForm.get('meetingSubject')?.invalid &&
        meetingForm.get('meetingSubject')?.touched

      "
    >
      Subject is required
    </mat-error>
    <mat-error *ngIf="meetingForm.get('meetingSubject')?.hasError('maxlength')">
      Subject cannot exceed 250 characters
    </mat-error>
  </mat-form-field>

  <!-- Participants -->
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Participants</mat-label>
    <mat-select formControlName="participants" multiple>
      <mat-option *ngFor="let user of usersList" [value]="user.userid">
        {{ user.firstname }} {{ user.lastname }}
      </mat-option>
    </mat-select>
  <mat-error *ngIf="meetingForm.get('participants')?.hasError('required') 
    && meetingForm.get('participants')?.touched">
    Please select at least one participant
  </mat-error>
  </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
    <mat-label>Meeting Link </mat-label>
    <input matInput formControlName="meetingLink" [errorStateMatcher]="errorStateMatcher" />
      <mat-error *ngIf="meetingForm.get('meetingLink')?.hasError('required') 
    && meetingForm.get('meetingLink')?.touched">
    Meeting link is required
  </mat-error>
  <mat-error *ngIf="meetingForm.get('meetingLink')?.hasError('maxlength')">
  Meeting link is too long
</mat-error>
  </mat-form-field>

  <!-- RECURRING OPTION -->
  <div class="recurring-option">
    <mat-checkbox formControlName="isRecurring" color="primary" (change)="onRecurringChange()">
      Recurring Meeting
    </mat-checkbox>
  </div>

  <!-- DATE & TIME SECTION -->
  <div class="datetime-section">
    <!-- Start Date/Time - Always Visible -->
    <div class="datetime-row">
      <!-- Start Date -->
      <mat-form-field appearance="outline" class="date-field">
        <mat-label>Start Date</mat-label>
        <input
          matInput
          [matDatepicker]="startPicker"
          formControlName="meetingStartDate"
          readonly
          [min]="today"
        />
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
              <mat-error *ngIf="meetingForm.get('meetingStartDate')?.hasError('required') 
        && meetingForm.get('meetingStartDate')?.touched">
        Start date is required
      </mat-error>
      </mat-form-field>

      <!-- Start Time -->
      <mat-form-field appearance="outline" class="time-field">
        <mat-label>Start Time</mat-label>
        <input
          matInput
          type="time"
          formControlName="meetingStartTime"
        />
              <mat-error *ngIf="meetingForm.get('meetingStartTime')?.hasError('required') 
        && meetingForm.get('meetingStartTime')?.touched">
        Start time is required
      </mat-error>
      </mat-form-field>

      <!-- End Time (only for non-recurring) -->
      <mat-form-field appearance="outline" class="time-field">
        <mat-label>End Time</mat-label>
        <input
          matInput
          type="time"
          formControlName="meetingEndTime"
        />
              <mat-error *ngIf="meetingForm.get('meetingEndTime')?.hasError('required') 
        && meetingForm.get('meetingEndTime')?.touched">
        End time is required
      </mat-error>
      </mat-form-field>
    </div>
  </div>

  <!-- SCHEDULER SELECTOR -->
  <div class="scheduler-section" *ngIf="meetingForm.get('isRecurring')?.value">
    <mat-form-field appearance="outline" class="full-width schedule-selector">
      <mat-label>Select Schedule</mat-label>
      <input 
        matInput 
        type="text" 
        formControlName="scheduleDesc" 
        (click)="selectSchedulerClick()" 
        [value]="selectedSchedule"
        readonly
        placeholder="Click to select recurrence schedule"
      />
      <!-- <button 
        mat-icon-button 
        matSuffix 
        *ngIf="scheduleid" 
        (click)="deleteSchedule()"
        type="button"
        style="margin-right: -8px;"
      >
        <mat-icon style="font-size: 18px;">close</mat-icon>
      </button> -->
    <mat-error *ngIf="meetingForm.get('scheduleDesc')?.hasError('required') 
      && meetingForm.get('scheduleDesc')?.touched">
      Schedule is required for recurring meetings
    </mat-error>
  <mat-error *ngIf="meetingForm.get('scheduleDesc')?.hasError('maxlength')">
  Schedule description cannot exceed 65535 characters
</mat-error>

    </mat-form-field>
    
    <!-- Schedule Preview -->
    <!-- <div *ngIf="selectedSchedule" class="schedule-preview">
      <mat-icon style="color: #0078d4; font-size: 16px; margin-right: 6px; vertical-align: middle;">schedule</mat-icon>
      <span style="font-size: 13px; color: #605e5c;">{{ selectedSchedule }}</span>
    </div> -->
  </div>

  <!-- AGENDA -->
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Agenda</mat-label>
    <textarea matInput rows="3" formControlName="agenda"></textarea>
    <mat-error *ngIf="meetingForm.get('agenda')?.hasError('maxlength')">
  Agenda cannot exceed 5000 characters
</mat-error>
  </mat-form-field>

  <!-- MEETING TYPE -->
  <!-- <mat-form-field appearance="outline" class="full-width">
    <mat-label>Meeting Type</mat-label>
    <mat-select formControlName="meetingType">
      <mat-option *ngFor="let type of meetingTypes" [value]="type.value">
        {{ type.label }}
      </mat-option>
    </mat-select>
  </mat-form-field> -->

</form>

<mat-dialog-actions align="end">
  <div class="actions">
    <app-common-button
      label="Back"
      title="Back"
      [buttonId]="1111"
      variant="cancel"
      width="110px"
      [critical]="false"
      (clicked)="close()"
      style="margin-left:6px;margin-right:6px;">
    </app-common-button>

    <app-common-button
      label="Submit"
      title="Submit"
      [buttonId]="1111"
      width="110px"
      [critical]="false"
      (clicked)="saveMeeting()"
      style="margin-left:6px;margin-right:6px;">
    </app-common-button>
  </div>
</mat-dialog-actions>